import React from "react";
import Image from "components/Image";

import * as styles from "./SimilarENs.module.less";
import { Link } from "utils";

/** @param {{ networks: readonly GatsbyTypes.SimilarExpertNetworkFragment[]; }} props */
export default function SimilarENs({ networks }) {
  return (
    <div className={styles.similarNetworks}>
      <fieldset className={styles.container}>
        <legend className={styles.label}>
          Discover more networks like this
        </legend>
        <div className={styles.content}>
          {networks.map((network) => {
            if (!network) return null;

            const {
              frontmatter: { title, logo },
              fields: { path },
            } = network;

            return (
              <Link
                to={path}
                className={styles.thumbnail}
                key={network.fields.path}
              >
                <Image
                  src={logo.image.childImageSharp}
                  alt={logo.alt || title}
                  title={title}
                />
              </Link>
            );
          })}
        </div>
      </fieldset>
    </div>
  );
}
